import { useCallback, useState } from 'react'

export default function usePagination() {
  const [page, setPage] = useState(1)
  const handleChangePage = useCallback((newPage) => {
    setPage(newPage)
  }, [])

  return {
    page,
    handleChangePage,
  }
}
